import { api } from "@/services/api"
import { queryClient } from "@/queryClient"

import type {
  CreateEditService,
  CommonService,
} from "./service"

export type UpdateServiceRequest = CreateEditService

export const updateService = async (
  serviceId: CommonService["id"],
  params: UpdateServiceRequest
) => {
  await api.put(`/beepaidgo/services/${serviceId}/`, {
    body: params,
  })

  queryClient.invalidateQueries([SERVICES_QUERY_KEY])
}
